import type { Edition } from "./types";

export const floripa2026: Edition = {
  slug: "floripa-2026",
  city: "Florianópolis",
  editionDates: "22a24JUL",
  eventStartDate: "2026-07-22",
  logoAsset: "/edition-logo.png",
  backgroundAsset: "/tdc-video-background.mp4",
};
